import { keyBy, keyById } from '@mews/fp';
import { createReducer } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    PRODUCT_ID_SELECTED,
    RATE_ID_SELECTED,
    SERVICE_ID_SELECTED,
    RATE_MANAGEMENT_DATA_FETCH_STARTED,
    RATE_MANAGEMENT_DATA_FETCH_SUCCEEDED,
    RATE_MANAGEMENT_DATA_FETCH_FAILED,
    PRICING_DATA_UPDATED,
    OCCUPANCY_FETCH_SUCCEEDED,
} from '../actions';

const INITIAL_STATE = {
    occupancy: {},
    pricing: {},
    rateId: null,
    ...META_STATE_SUCCEEDED,
};

const dataReducer = createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [OCCUPANCY_FETCH_SUCCEEDED]: (state, { totalOccupancies, resourceCategoryTypeOccupancies }: $TSFixMe) => ({
        ...state,

        occupancy: {
            totalOccupancies,
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            resourceCategoryTypeOccupancies: keyBy('resourceCategoryType', resourceCategoryTypeOccupancies),
        },
    }),
    [PRICING_DATA_UPDATED]: (
        // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
        state,
        { attributeType, basePrice, attributePrices, capacityOffsetAdjustments, rateAdjustment }: $TSFixMe
    ) => ({
        ...state,

        pricing: {
            attributeType,
            basePrice,
            attributePrices: keyById(attributePrices),
            capacityOffsetAdjustments,
            rateAdjustment,
        },
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [PRODUCT_ID_SELECTED]: (state, { productId }: $TSFixMe) => ({
        ...state,
        productId,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RATE_ID_SELECTED]: (state, { rateId }: $TSFixMe) => ({
        ...state,
        rateId,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SERVICE_ID_SELECTED]: (state, { serviceId }: $TSFixMe) => ({
        ...state,
        serviceId,
    }),
    ...createEntityAsyncMetaHandlers({
        STARTED: RATE_MANAGEMENT_DATA_FETCH_STARTED,
        SUCCEEDED: RATE_MANAGEMENT_DATA_FETCH_SUCCEEDED,
        FAILED: RATE_MANAGEMENT_DATA_FETCH_FAILED,
    }),
});

export default dataReducer;
